import React from 'react';
import axios from 'axios';
import { toast, } from 'react-toastify';
import RegularButton from "../../components/CustomButtons/Button.jsx";
import Button from '@material-ui/core/Button';
import '../../assets/css/Order.css'
import { withStyles } from '@material-ui/core/styles';
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Card from "../../components/Card/Card.jsx";
import CardBody from "../../components/Card/CardBody.jsx";
import CustomInput from '../../components/CustomInput/CustomInput';
import { NavLink } from 'react-router-dom';
import { BASE_URL } from '../../utils/handleApi'

const useStyles = (theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
            marginBottom: theme.spacing(5)
        }
    },
    rootButton: {
        '& > *': {
            margin: theme.spacing(1),
            marginTop: theme.spacing(-1.8),
            marginLeft: theme.spacing(1.5)
        }
    },
    paper: {
        backgroundColor: "red"
    },
    margin: {
        // margin: theme.spacing(1),
        marginRight: theme.spacing(10)
    },
    withoutLabel: {
        marginTop: theme.spacing(2),
    },
    textField: {
        width: '16vw',
    },

});
class Detailstable extends React.Component {
    state = {
      nameState: "",
      client_noState: "",
      billing_contactState: "",
      streetState: "",
      cityState: "",
      stateState: "",
      zipState: "",
      feeState: "",

      name: "",
      client_no: "",
      billing_contact: "",
      street: "",
      city: "",
      state: "",
      zip: "",
      fee: "10",

      required: "",
      requiredState: "",
      number: "",
      numberState: "",
      equalTo: "",
      whichEqualTo: "",
      equalToState: "",
      
      minLength: "",
      minLengthState: "",
      maxLength: "",
      maxLengthState: "",
      range: "",
      rangeState: "",
      minValue: "",
      minValueState: "",
      maxValue: "",
      maxValueState: "",
      
      isFormSubmitting: false,
  }

    componentDidMount(){
      document.getElementById("zip").min = "0";
      document.getElementById("fee").min = "0";
      const tokenStr = localStorage.getItem('token')
      axios.post(`${BASE_URL}/lender/newId`,{
        "type": "M"
      },{
        headers: {
          'Authorization': `Bearer ${tokenStr}`
        }
      })
      .then(res => {
        const { lender_id } = res.data
        this.setState({
          client_no: `${lender_id.toString().padStart(3,0)}`,
          client_noState: "success"
        })
      })
      .catch(() => {
        toast.error('Some error happened!')
      })
    }

    verifyEmail(value) {
        var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailRex.test(value)) {
            return true;
        }
        return false;
    }
  
    verifyLength(value, length) {
        if (value.length >= length) {
        return true;
        }
        return false;
    }
   
    verifyNumber(value) {
        var numberRex = new RegExp("^[0-9]+$");
        if (numberRex.test(value)) {
        return true;
        }
        return false;
    }
    
    change(event, stateName, type, stateNameEqualTo, maxValue) {
        switch (type) {
          case "email":
            if (this.verifyEmail(event.target.value)) {
              this.setState({ [stateName + "State"]: "success" });
              this.setState({ [stateName]: event.target.value });
            } else {
              this.setState({ [stateName + "State"]: "error" });
            }
            break;
          case "password":
            if (this.verifyLength(event.target.value, 1)) {
              this.setState({ [stateName + "State"]: "success" });
              this.setState({ [stateName]: event.target.value });
            } else {
              this.setState({ [stateName + "State"]: "error" });
            }
            break;
          case "equalTo":
            if (this.compare(event.target.value, this.state[stateNameEqualTo])) {
              this.setState({ [stateName + "State"]: "success" });
              this.setState({ [stateName]: event.target.value });
            } else {
              this.setState({ [stateName + "State"]: "error" });
            }
            break;
          case "checkbox":
            if (event.target.checked) {
              this.setState({ [stateName + "State"]: "success" });
              this.setState({ [stateName]: event.target.value });
            } else {
              this.setState({ [stateName + "State"]: "error" });
            }
            break;
          case "number":
            if (this.verifyNumber(event.target.value)) {
              this.setState({ [stateName + "State"]: "success" });
              this.setState({ [stateName]: event.target.value });
            } else {
              this.setState({ [stateName + "State"]: "error" });
            }
            break;
          case "length":
            if (this.verifyLength((event.target.value).replace(/ /g,""), stateNameEqualTo)) {
              this.setState({ [stateName + "State"]: "success" });
              this.setState({ [stateName]: event.target.value });
            } 
            else {
              this.setState({ [stateName + "State"]: "error" });
            }
            break;
          case "max-length":
            if (!this.verifyLength(event.target.value, stateNameEqualTo + 1)) {
              this.setState({ [stateName + "State"]: "success" });
              this.setState({ [stateName]: event.target.value });
            } else {
              this.setState({ [stateName + "State"]: "error" });
            }
            break;
          case "url":
            if (this.verifyUrl(event.target.value)) {
              this.setState({ [stateName + "State"]: "success" });
              this.setState({ [stateName]: event.target.value });
            } else {
              this.setState({ [stateName + "State"]: "error" });
            }
            break;
          case "min-value":
            if (
              this.verifyNumber(event.target.value) &&
              event.target.value >= stateNameEqualTo
            ) {
              this.setState({ [stateName + "State"]: "success" });
              this.setState({ [stateName]: event.target.value });
            } else {
              this.setState({ [stateName + "State"]: "error" });
            }
            break;
          case "max-value":
            if (
              this.verifyNumber(event.target.value) &&
              event.target.value <= stateNameEqualTo
            ) {
              this.setState({ [stateName + "State"]: "success" });
              this.setState({ [stateName]: event.target.value });
            } else {
              this.setState({ [stateName + "State"]: "error" });
            }
            break;
          case "range":
            if (
              this.verifyNumber(event.target.value) &&
              event.target.value >= stateNameEqualTo &&
              event.target.value <= maxValue
            ) {
              this.setState({ [stateName + "State"]: "success" });
              this.setState({ [stateName]: event.target.value });
            } else {
              this.setState({ [stateName + "State"]: "error" });
            }
            break;
          default:
            break;
        }
        switch (type) {
          case "checkbox":
            this.setState({ [stateName]: event.target.checked });
            break;
          default:
            this.setState({ [stateName]: event.target.value });
            break;
        }
      }

    addLender = () => {
        const { client_no, name, billing_contact, street, city, state, zip, fee } = this.state;
        this.setState({ isFormSubmitting: true })
        let isValid = true

        if (name.trim() === "" ) {
        this.setState({ nameState: "error" });
        isValid = false
        }
        if (billing_contact.trim() === "" ) {
        this.setState({ billing_contactState: "error" });
        isValid = false
        }
        if (street.trim() === "" ) {
        this.setState({ streetState: "error" });
        isValid = false
        }
        if (city.trim() === "" ) {
        this.setState({ cityState: "error" });
        isValid = false
        }
        if (state.trim() === "" ) {
        this.setState({ stateState: "error" });
        isValid = false
        }
        if (zip.trim() === "") {
        this.setState({ zipState: "error" });
        isValid = false
        }
        if (fee.trim() === "") {
          this.setState({ feeState: "error" });
          isValid = false
        }
        if(!isValid){
          this.setState({ isFormSubmitting: false })
        }

        if(isValid){
          let tokenStr = localStorage.getItem('token')
          axios.post(`${BASE_URL}/lender/add`, {
              "client_no": client_no,
              "name": name,
              "billing_contact": billing_contact,
              "street": street,
              "city": city,
              "state": state,
              "zip": zip,
              "cost": fee,
          },{
            headers: {
              'Authorization': `Bearer ${tokenStr}`
          }
          })  
          .then(() => {
            toast.success('Lender Created Successfully!', {
              onClose: () => this.props.navigateBack()
            })
          })
          .catch(() => {
            toast.error('Some error happened!', {
              onClose: () => this.setState({ isFormSubmitting: false })
            })
          })
        }
    }

    disableHyphen = (e) => {
      if(e.keyCode === 189){
          e.preventDefault();
      }
   }

    render() {
        const { classes } = this.props
        const { nameState, client_noState, billing_contactState, streetState, cityState, stateState, zipState, isFormSubmitting, client_no, fee, feeState } = this.state;
        return (
            <div>
                <GridContainer className="form-container" style={{ width: '60vw', margin: '0 auto', backgroundColor: 'white' }}>
                    <GridItem xs={12}>
                        <Card>
                        <div className={classes.rootButton}>
                            <Button variant="contained" style={{ boxShadow: '0px 3px 5px -2px #AAAAAA',outline: 'none', color: 'white', height: '50px', width: '170px', fontFamily: 'Roboto-Bold', backgroundColor: '#04AB23', textTransform: 'none' }} disabled>
                                Add Lender
                            </Button>
                            <NavLink to="/MyLenders"> 
                              <div className={classes.rootButton} style={{ float: "right" }}>
                                <Button variant="contained" style={{ boxShadow: '0px 3px 5px -2px #AAAAAA',outline: 'none', 
                                color: 'white', height: '50px', width: '120px', fontFamily: 'Roboto-Bold', 
                                backgroundColor: '#04AB23', textTransform: 'none', textAlign: 'center', marginBottom: '10px' }} 
                                >
                                  Back
                                </Button>
                              </div>
                            </NavLink>
                        </div>
                      <CardBody>
                      <form>
                        <CustomInput
                          success={nameState === "success"}
                          error={nameState === "error"}
                          labelText="Name *"
                          id="name"
                          formControlProps={{
                              fullWidth: true
                          }}
                          inputProps={{
                              onChange: event => 
                              this.change(event, "name", "length", 1),
                              type: "text",
                          }}
                        />
                        <CustomInput
                          success={client_noState === "success"}
                          error={client_noState === "error"}
                          labelText="Client No *"
                          id="client_no"
                          formControlProps={{
                              fullWidth: true,
                              style: {borderBottom: '1px solid #04ab23'}
                          }}
                          inputProps={{
                              onChange: event =>
                              this.change(event, "client_no", "length", 1),
                              type: "number",
                              value: client_no,
                              readOnly: true,
                              disabled: true
                          }}
                        />
                        <CustomInput
                          success={billing_contactState === "success"}
                          error={billing_contactState === "error"}
                          labelText="Billing Contact Email *"
                          id="billing_contact"
                          formControlProps={{
                              fullWidth: true
                          }}
                          inputProps={{
                              onChange: event =>
                              this.change(event, "billing_contact", "email"),
                              type: "email"
                          }}
                        />
                        <CustomInput
                          success={streetState === "success"}
                          error={streetState === "error"}
                          labelText="Street *"
                          id="street"
                          formControlProps={{
                              fullWidth: true
                          }}
                          inputProps={{
                              onChange: event =>
                              this.change(event, "street", "length", 1),
                              type: "text"
                          }}
                        />
                        <CustomInput
                          success={cityState === "success"}
                          error={cityState === "error"}
                          labelText="City *"
                          id="city"
                          formControlProps={{
                              fullWidth: true
                          }}
                          inputProps={{
                              onChange: event =>
                              this.change(event, "city", "length", 1),
                              type: "text"
                          }}
                        />
                        <CustomInput
                          success={stateState === "success"}
                          error={stateState === "error"}
                          labelText="State *"
                          id="state"
                          formControlProps={{
                              fullWidth: true
                          }}
                          inputProps={{
                              onChange: event =>
                              this.change(event, "state", "length", 1),
                              type: "text"
                          }}
                        />
                        <CustomInput
                          success={zipState === "success"}
                          error={zipState === "error"}
                          labelText="ZIP *"
                          id="zip"
                          formControlProps={{
                              fullWidth: true
                          }}
                          inputProps={{
                              onChange: event =>
                              this.change(event, "zip", "length", 1),
                              type: "number",
                              onKeyDown: (e) => this.disableHyphen(e)
                          }}
                        />
                        <CustomInput
                          success={feeState === "success"}
                          error={feeState === "error"}
                          labelText="Fee ($) *"
                          id="fee"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            onChange: event =>
                              this.change(event, "fee", "length", 1),
                            type: "number",
                            value: fee,
                            onKeyDown: (e) => this.disableHyphen(e)
                          }}
                        />
                      </form>
                    </CardBody>
                    </Card>
                      <div className={classes.rootButton} style={{textAlign: 'center'}}>
                        <RegularButton 
                          disabled={isFormSubmitting}
                          onClick={this.addLender} 
                          variant="contained" 
                          style={{ boxShadow: '0px 3px 5px -2px #AAAAAA',outline: 'none', color: 'white', height: '50px', width: '190px', fontFamily: 'Roboto-Bold', backgroundColor: '#04AB23', textTransform: 'none', textAlign: 'center', marginBottom: '100px' }} 
                        >Add Lender
                        </RegularButton>
                      </div>
                    </GridItem>
                </GridContainer>
            </div>
        )
    }
}
export default withStyles(useStyles, { withTheme: true })(Detailstable)